/**
 * Shared "In Recess" badge treatment for the public app. Raw orange because no semantic Badge variant
 * is orange (`variant="warning"` is yellow); matches the console off-air pill in `stream-status-badge.tsx`
 * (no border). Always pair it with recess text so state is never conveyed by color alone (WCAG).
 */
export const RECESS_BADGE_CLASS = 'bg-orange-500/15 text-orange-700 dark:text-orange-300';
